import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster, toast } from "sonner";
import "@/App.css";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import EditorialMarquee from "@/components/EditorialMarquee";
import ManifestoChapters from "@/components/ManifestoChapters";
import ProductCatalog from "@/components/ProductCatalog";
import MaterialLab from "@/components/MaterialLab";
import CittiglioBanner from "@/components/CittiglioBanner";
import ProjectGallery from "@/components/ProjectGallery";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import SampleBoard from "@/components/SampleBoard";
import CartDrawer from "@/components/CartDrawer";
import { commercialConfig, products } from "@/config/commercialConfig";

export { commercialConfig, products };
export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const PHONE_NUMBER = "+393801028819";
export const WHATSAPP_NUMBER = "393801028819";
export const whatsappLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    message || "Buongiorno StoneInLove, vorrei ricevere informazioni sui travertini romani.",
  )}`;

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

function Home() {
  const [sampleIds, setSampleIds] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);
  const [quoteDraft, setQuoteDraft] = useState(null);

  useEffect(() => {
    const revealObserver = new IntersectionObserver(
      (entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        }
      }),
      { threshold: 0.14 },
    );
    document.querySelectorAll(".reveal").forEach((element) => revealObserver.observe(element));
    return () => revealObserver.disconnect();
  }, []);

  const requestQuote = (material = "Navona Avorio") => {
    setQuoteDraft({ material });
    scrollTo("contatti");
  };

  const addSample = (product) => {
    setSampleIds((current) => current.includes(product.id) ? current : [...current, product.id]);
  };

  const addToCart = (product) => {
    setCartItems((current) => {
      const existing = current.find((item) => item.id === product.id);
      if (existing) return current.map((item) => item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item);
      return [...current, { ...product, quantity: 1, area: product.salesMode === "area" ? 1 : null }];
    });
  };

  const updateCartItem = (id, values) => {
    setCartItems((current) => current.map((item) => item.id === id ? { ...item, ...values } : item));
  };

  const removeCartItem = (id) => {
    setCartItems((current) => current.filter((item) => item.id !== id));
  };

  const openCart = () => {
    toast.dismiss();
    setCartOpen(true);
  };

  const sampleProducts = products.filter((product) => sampleIds.includes(product.id));

  return (
    <div className="site-shell">
      <Header cartCount={cartItems.length} onOpenCart={openCart} onQuote={() => requestQuote()} />
      <main className="site-main">
        <CittiglioBanner />
        <HeroSection onQuote={() => requestQuote()} />
        <EditorialMarquee />
        <ManifestoChapters />
        <ProductCatalog products={products} onAddSample={addSample} onAddToCart={addToCart} onQuote={requestQuote} />
        <SampleBoard sampleProducts={sampleProducts} onRemoveSample={(id) => setSampleIds((current) => current.filter((sampleId) => sampleId !== id))} onClearSamples={() => setSampleIds([])} />
        <MaterialLab />
        <ContactSection initialQuote={quoteDraft} />
        <ProjectGallery />
      </main>
      <Footer />
      <CartDrawer isOpen={cartOpen} items={cartItems} onClose={() => setCartOpen(false)} onUpdate={updateCartItem} onRemove={removeCartItem} />
      <Toaster position="bottom-left" toastOptions={{ style: { background: "#141412", color: "#F7F4EE" } }} />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}
